import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-tw';
import cN from 'classnames';
import { LightBox } from '@lion-design/core';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { I_SkiItem } from '@Redux/detail/Group/interfaces';

enum SkiTypes {
    ski = 1,
    snowboard = 2,
}

interface I_Props {
    open: boolean;
    ToggleLightBox: () => void;
}

function GroupDetailSki({ open = true, ToggleLightBox }: I_Props) {
    const { Ski, GroupInfo } = useSelector((state: RootState) => state.groupReducer);
    const { t } = useTranslation();

    return Ski ? (
        <LightBox
            title="滑雪報名現況"
            className={cN(styles.container, 'group_detail_ski')}
            open={open}
            ToggleLightBox={ToggleLightBox}
        >
            <h3 className={styles.title}>{Ski!.TourName}</h3>
            <div>
                <div>
                    {t('GroupID')}：{GroupInfo.GroupID}
                </div>
                <div className={styles.goDate}>
                    <span className={styles['goDate__title']}>出發日期：</span>
                    <span>
                        {Ski!.GoDate}~{Ski!.BackDate} 共{Ski!.TourDays}天
                    </span>
                </div>
            </div>
            <ul>
                {Ski!.SkiList.map((item: I_SkiItem, i: number) => (
                    <li key={i} className={styles['ski-item']}>
                        <h4>{item.SkiType === SkiTypes.ski ? 'SKI' : 'SNOW BOARD'}</h4>
                        <div className={styles['ski-item__detail']}>
                            <span>已付訂：{item.PaidPeople}</span>
                            <span>總報名人數：{item.ApplyTotal}</span>
                        </div>
                    </li>
                ))}
            </ul>
            <div>以上為已填寫滑雪活動資料的人數統計</div>
        </LightBox>
    ) : null;
}

export default GroupDetailSki;
